var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C15.376 2.55579 10.9572 4.41744 7.68731 7.68731C4.41744 10.9572 2.55579 15.376 2.5 20C2.55579 24.624 4.41744 29.0428 7.68731 32.3127C10.9572 35.5826 15.376 37.4442 20 37.5C24.624 37.4442 29.0428 35.5826 32.3127 32.3127C35.5826 29.0428 37.4442 24.624 37.5 20C37.4442 15.376 35.5826 10.9572 32.3127 7.68731C29.0428 4.41744 24.624 2.55579 20 2.5ZM30 20C30 20.6904 29.4404 21.25 28.75 21.25H21.25V28.75C21.25 29.4404 20.6904 30 20 30C19.3096 30 18.75 29.4404 18.75 28.75V21.25H11.25C10.5596 21.25 10 20.6904 10 20C10 19.3096 10.5596 18.75 11.25 18.75H18.75V11.25C18.75 10.5596 19.3096 10 20 10C20.6904 10 21.25 10.5596 21.25 11.25V18.75H28.75C29.4404 18.75 30 19.3096 30 20Z",
    fill: "#8D9293"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/AddCircle.518885517649398a5b428777e9eeb6cc.svg";
export { ForwardRef as ReactComponent };